import * as React from 'react';
import * as Sentry from '@sentry/react';
import styled from 'styled-components';
import { sentryDsn, Version } from '../config.local';
import {
	getAccessToken,
	getCandidateIdFromAccessToken,
	getCustomerIdFromAccessToken,
	getCustomerUserIdFromAccessToken,
	hasCandidateRole
} from '../core/session';

const ErrorBoundary = (props: Props) => {
	if (sentryDsn !== null) {
		Sentry.configureScope(setSentryScope);
	}
	return (
		<Sentry.ErrorBoundary
			fallback={({ error, componentStack }) => (
				<StyledArticle>
					<Title>Something went wrong.</Title>
					<Details>
						<div>{error.toString()}</div>
						<div>{componentStack}</div>
					</Details>
				</StyledArticle>
			)}
			showDialog
		>
			{props.children}
		</Sentry.ErrorBoundary>
	);
};

export default ErrorBoundary;

interface Props {
	children: React.ReactNode;
}

const StyledArticle = styled.article`
	display: table;
	margin: 100px auto;

	a {
		margin: 20px 0;
	}
`;

const Details = styled.details`
	font-size: 15px;
	margin: 14px 0;
	white-space: pre-wrap;
`;

const Title = styled.h4`
	text-align: center;
`;

const setSentryScope = (scope: Sentry.Scope) => {
	scope.setExtra('AppEndpoint', document.location.origin);
	if (Version !== null) scope.setExtra('Version', Version);
	if (getAccessToken() !== null) {
		scope.setExtra('CustomerId', getCustomerIdFromAccessToken());
		if (hasCandidateRole()) {
			scope.setExtra('CandidateId', getCandidateIdFromAccessToken());
		} else {
			scope.setExtra('CustomerUserId', getCustomerUserIdFromAccessToken());
		}
	}
};
